import { render, staticRenderFns } from "./LoginNewCopy.vue?vue&type=template&id=714ca28e&scoped=true&"
import script from "./LoginNewCopy.vue?vue&type=script&lang=js&"
export * from "./LoginNewCopy.vue?vue&type=script&lang=js&"
import style0 from "./LoginNewCopy.vue?vue&type=style&index=0&lang=css&"
import style1 from "./LoginNewCopy.vue?vue&type=style&index=1&id=714ca28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714ca28e",
  null
  
)

export default component.exports